/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Group, Copy, Title, BodyCopy, Accent, Link } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './passwordreset_styles';
// import styles from 'pages/auth/requestdemo/requestdemo_styles';



/* ========== ~~~~~~~~~~ AUTH PASSWORD RESET ~~~~~~~~~~ ========== */
class PasswordResetPage extends Component {
    render() {
        return(
            <Page name={`passwordreset`} klass={this.props.classes.passwordreset}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Password Reset</h2>
                        </Title>
                        <BodyCopy>
                            <p>{`We sent an email${!!this.props.email ? ` to ${this.props.email}` : ``} with instructions and a password reset link.`}</p>
                            <p><Accent>Email didn’t arrive? <Link type={`internal`} action={`auth/resetpassword`} text={`Try Again`} />.</Accent></p>
                        </BodyCopy>
                    </Copy>
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PasswordResetPage);
